module.exports = __webpack_public_path__ + "img/MS.387b48c6.svg";